import React from 'react'
import { Icon, Popover, Typography } from '@material-ui/core'
import { Build } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
}))


export default function OverridePopover({ onClick, crewOverride, vendorOverride }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  
  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget)
  }
  
  const handlePopoverClose = () => {
    setAnchorEl(null)
  }
  
  const open = Boolean(anchorEl)
  return (
    <div
      style={{ cursor: 'pointer' }}
      aria-owns={open ? 'mouse-over-popover' : undefined}
      aria-haspopup="true"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <Build style={{ width: 20 }} color="primary"/>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>Vendor Override: {vendorOverride}</Typography>
        <Typography>Crew Override: {crewOverride}</Typography>
      </Popover>
    </div>
  )
}